import * as React from 'react';
// import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const LiveClassPlayer = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    data-id="live-class-player"
    className={cn('rounded-[12px] bg-white shadow-dropshadow-sm p-3 w-full flex flex-col', className)}
    {...props}
  />
));
LiveClassPlayer.displayName = 'LiveClassPlayer';

const LiveClassPlayerEmbed = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    data-id="live-class-player-embed"
    className={cn('rounded-[12px] overflow-hidden translate-y-0 flex-grow aspect-[16/9] relative [&>iframe]:absolute [&>iframe]:w-full [&>iframe]:h-full', className)}
    {...props}
  />
));
LiveClassPlayerEmbed.displayName = 'LiveClassPlayerEmbed';

export { LiveClassPlayer, LiveClassPlayerEmbed };
